
export const past2024 = {
  subTitle: '—— 西丽湖金融科技大学生挑战赛',
  subTitleEn: 'FinTechathon 深圳国际金融科技大赛',
  titleImg: require('@/assets/img/2024.png'),
  mobileTitleImg: require('@/assets/img/2024.png'),
  introduction: {
    subTitle: '微众银行金融科技高校技术大赛',
    subTitleEn: 'FinTechathon',
    // certificate: require('../../../assets/img/awards/certificate.png'),
    // mobileCertificate: require('../../../assets/img/awards/certificate-wap.png'),
    intro: [
      '12月7日-9日，在深圳市地方金融管理局的战略指导下，由深圳大学、微众银行、深圳香蜜湖国际金融科技研究院等联合主办的2024 FinTechathon深圳国际金融科技大赛——西丽湖金融科技大学生挑战赛（以下简称“大赛”）在深圳圆满落幕，并举行大赛颁奖典礼。深圳市委金融办副主任、市地方金融管理局副局长朱江，深圳大学党委常委、副校长汪永成，微众银行副行长兼首席信息官马智涛出席活动并致辞。',
      '本届大赛历时两个半月，吸引了2450名高校学生报名，组成534支队伍，提交了321份作品。经过初赛、复赛的层层筛选和激烈角逐后，为期 2 天的决赛在深圳大学-丽湖校区举行，人工智能和区块链赛道的队伍在完成“36 小时黑客松”不间断封闭开发后进行现场答辩，产品经理赛道的队伍则在完成作品完整版创作后进行现场答辩。最终，区块链、人工智能、产品经理三个赛道的前三甲名单终于出炉，他们获得了总计 69 万元的奖金及区块链数字证书。以下为具体获奖名单：'
    ],
    poster: require('@/assets/transSave/resource/image/2024/4a1ae8113cc697405c7a6b07df7a2ce.png'),
    video: 'https://course.csdnimg.cn/asset/3cb953597d6fcc2cde5c060c4d280696/play_video/e9449a170e415169eaafa5a8356f1104.mp4'
  },

  finalist: {
    // title: '入围决赛队伍',
    // subTitle: 'FINALIST',
    content: [
      {
        alias: 'first',
        title: '一等奖',
        list: [
          {
            image: require('@/assets/transSave/resource/image/2024/image.png'),
            title: 'Eureka团队',
            alias: 'ai',
            type_title: '人工智能赛道',
            product: '《One-shot SSVFATE个性化自监督纵向联邦信贷评估系统》',
            member: '陈帅、尹祥、王佳杰、程远哲、徐纪元',
            school: '浙江财经大学、上海交通大学',
            pro_intro: 'One-shot SSVFATE个性化自监督纵向联邦信贷评估系统旨在解决金融信贷评估领域中的核心挑战，包括数据隐私保护与协作效率的冲突、标签稀缺与对齐样本稀疏等问题。基于FATE平台，本系统创新性地将自监督对比学习与纵向联邦学习技术相结合，充分利用无标签数据进行预训练，并创新性地提出联邦对比实例相似性学习，深度挖掘各参与方无标签数据的潜在关联性和金融价值，提升自监督训练中VFL模型的域间泛化能力和表征学习能力的同时避免与自监督学习优化目标的冲突。双阶段自监督学习克服了标签稀缺、对齐样本稀疏等局限性，实现了面向真实业务场景的跨机构纵向联邦学习。此外，One-shot SSVFATE具备高度模块化与扩展性，其核心算法能够跨领域应用于个性化营销、医疗诊断等任务，推动业务智能化与创新，具有重要的商业价值和广阔的应用前景。'
          },
          {
            image: require('@/assets/transSave/resource/image/2024/image1.png'),
            title: '智易链',
            product: '《AIGC模型可信监管交易溯源平台》',
            alias: 'blockchain',
            type_title: '区块链赛道',
            member: '高剑博、卫亦航、雷良齐、魏震涛、寇栩菡',
            school: '北京理工大学',
            pro_intro: '模型资产的版权保护、流通交易、安全治理是激活数据要素价值的有效路径。由于模型存在形式特殊，导致模型确权困难、交易缺乏可信基础、应用监管溯源效率低，引发模型所有者对于模型安全的顾虑。本作品围绕版权难保障、主体难可信、交易难监管、应用难溯源四个方面开展研究。以基于生成式模型水印的技术框架和基于区块链的信任基础设施作为底层支撑、模型链上链下的交易机制和生成式模型服务溯源技术作为技术支撑，实现了稳定身份标识符嵌入、模型资产侵权追责、生成式模型服务溯源。'
          },
          {
            image: require('@/assets/transSave/resource/image/2024/image2.png'),
            title: 'URich',
            product: '《成长盈》',
            alias: 'pm',
            type_title: '产品经理赛道',
            member: '郑佳琦、车韦萱、马菁慧、郭心蕊',
            school: '深圳大学',
            pro_intro: '当前大学生普遍面临理财知识薄弱、冲动消费及就业过渡期经济压力等问题，成长盈致力于为年轻人提供一款集储蓄、理财教育、游戏互动和社区交流于一体的智能财务管理平台。平台通过设立“毕业基金”与“职场基金”，结合AIGC理财助手提供个性化咨询与动态理财方案，同时创新性引入游戏化学习机制，让用户在趣味中获取理财知识。用户可通过剧本互动游戏模拟理财场景，逐步养成良好的财务规划习惯。此外，社交圈功能支持理财经验分享与内容激励，提升用户粘性与参与感。成长盈旨在帮助大学生逐步积累缓冲资金，渡过就业过渡期，最终实现经济独立与长期理财目标。'
          }
        ]
      },
      {
        alias: 'second',
        title: '二等奖',
        list: [
          {
            image: require('@/assets/transSave/resource/image/2024/image3.png'),
            title: '向日葵',
            product: 'FDGAN—基于生成对抗网络的保险欺诈检测器',
            alias: 'ai',
            type_title: '人工智能赛道',
            member: '相洪振、王晓光',
            school: '西安交通大学',
            pro_intro: '在车险反欺诈业务场景中，欺诈用户通常伪装成正常用户骗取理赔款，而且他们的数量也远远少于正常用户，这往往导致分类器产生过拟合，难以识别欺诈。一种有效的方法是引入生成模型学习欺诈样本的分布，合成足够多的欺诈样本帮助训练分类器。然而，真实的欺诈样本数量太少以至于生成模型难以充分学习样本分布。基于此，本项目提出了一种基于生成对抗网络的模型 FDGAN，利用欺诈样本和正常样本的共同特征和差异特征分别辅助学习他们各自的分布，合成高质量的欺诈样本和正常样本帮助训练 XBGoost分类器，大大提高了欺诈检测效果。',
          },
          {
            image: require('@/assets/transSave/resource/image/2024/image4.png'),
            title: '密文枢纽队',
            product: 'CipherBridge可验证多⽅密⽂计算平台',
            alias: 'blockchain',
            type_title: '区块链赛道',
            member: '余晓霄、曹懿月',
            school: '香港科技大学',
            pro_intro: 'CipherBridge是一个基于零知识证明和全同态加密结合技术 (zkFHE) 的可验证多方密文计算平台，旨在为多方数据的流转、交易、共享和计算提供隐私解决方案。平台支持任意多个参与方或数据托管方使用用户的全同态加密公钥加密本地隐私数据，并上传密文至FISCO BCOS区块链进行共享。业务方能根据用户的具体业务需求，执行链上密文之间或密文与明文之间的任意算法计算操作，并验证用户使用私钥和密文解密出的结果。',
          },
          {
            image: require('@/assets/transSave/resource/image/2024/image5.png'),
            title: '花YOUNG',
            product: '花YOUNG 理财专区',
            alias: 'pm',
            type_title: '产品经理赛道',
            member: '李正可、王小东、温瑞琪',
            school: '浙江大学',
            pro_intro: '服务于年轻用户群体管理个人财务的目标，针对其存钱需求迫切但缺乏有效工具、理财需求明确但缺乏入门知识的痛点，打造花YOUNG app，推出“花YOUNG短剧攒”“花YOUNG理财”“花YOUNG生活”等系列特色功能，从储蓄、投资、消费等不同维度全方位助力青年用户构建科学、合理、有效的财富管理模式，同时结合社交玩法，培养金融这一垂类场景的内容社区生态，帮助用户更轻松地进行财富积累，追踪个人财务状况。',
          }
        ]
      },
      {
        alias: 'third',
        title: '三等奖',
        list: [
          {
            image: require('@/assets/transSave/resource/image/2024/image6.png'),
            title: '爱国者联盟队',
            product: '基于FATE-LLM的老年人金融数字人助手',
            alias: 'ai',
            type_title: '人工智能赛道',
            member: '唐昭辰瑄、陈林璟、谢之越、刘焕彬',
            school: '深圳大学',
            pro_intro: '我们的项目是一款专为老年人设计的AI金融数字人助手，旨在简化金融操作并提升金融素养。该助手通过易用的数字人界面实现语音交流，降低操作复杂性。它集成了多功能金融助手，包括数据分析、市场洞察、金融知识普及和记忆辅助，以应对老年人在金融市场的挑战。此外，项目采用FATE-LLM的加密推理技术，确保用户数据隐私安全。通过优化InferDPT模块，我们实现了更精准的隐私保护和更高质量的回答输出。',
          },
          {
            image: require('@/assets/transSave/resource/image/2024/image7.png'),
            title: 'TANKLAB区块链小分队',
            product: '基于区块链的AIGC全生命周期版权管理系统',
            alias: 'blockchain',
            type_title: '区块链赛道',
            member: '马立原、胡登铖、韦人硕、栾博越、吕一然',
            school: '天津大学',
            pro_intro: '当前AIGC技术已取得显著进展，但现有管理体系在多个关键环节存在显著不足，导致数据来源与授权范围难以追溯，可能引发数据侵权或滥用的问题。通过构建覆盖训练、生成和使用的区块链管理闭环，本项目旨在为AIGC的分布式协作与全生命周期管理提供系统化技术支撑，打造版权单元编码、链上链下映射和节点跨域协作三方面创新成果，以FISCO BCOS作为底链，实际部署亚非拉三大洲节点，全面提升AIGC在内容生成与管理中的可信性和效率，推动AIGC技术在透明管理、版权保护及跨域协作等方面的应用落地。',
          },
          {
            image: require('@/assets/transSave/resource/image/2024/image8.png'),
            title: '我在腾讯吃烧鹅',
            product: '银行软件',
            alias: 'pm',
            type_title: '产品经理赛道',
            member: '鲁添威、崔嘉辉、金艺瑛、卢墨菲',
            school: '大连海事大学、中山大学、大连理工大学、山东大学',
            pro_intro: '在使用支付类型的软件时，用户存在还款日期不灵活，借还款手续复杂，逾期利息高，还款提示不明显，缺乏预算管理的问题，团队根据银行中的贷款，账本，理财业务针对性推出“花一笔备用钱包”“自律计划”“心愿储钱罐”三大功能。“花一笔”为用户提供作为备用钱包的贷款服务，用户每消费一笔后需还款数会随机减少一笔；“自律计划”用户可以对不同种类的消费设置预算，完成后会拿到不同数额的奖金；“心愿储钱罐支持用户将省下的钱存入，并支持多人管理，提供仪式化取款。通过以上三项主要功能解决用户痛点问题 ',
          }
        ]

      }
    ]
  },


  videos: {
    titleCh: '直播回顾',
    titleEn: '',
    list: [
      {
        imgUrl: require('@/assets/transSave/resource/image/2024/live1.png'),
        contentText: '产品经理赛道线上公开课',
        video: 'https://live.csdn.net/room/csdnnews/ZMeqlm2B'
      },
      {
        imgUrl: require('@/assets/transSave/resource/image/2024/live2.png'),
        contentText: '区块链&人工智能赛道线上公开课',
        video: 'https://live.csdn.net/room/csdnnews/SvEyAYYL'
      }
    ],
    buttonText: '',
    buttonLink: ''
  }
}
